<section>

  <h2> Por favor ingresa la siguiente información para continuar: </h2>

  <form [formGroup]="form">

    <div class="row">

      <div class="col-12 mb-3">
        <label> Número telefónico <span class="input-required"> * </span> </label>
        <input class="form-control mt-2" type="text" maxlength="10" formControlName="phoneNumber"
          [ngClass]="hasErrors('phoneNumber')">
        <span *ngIf="isInvalid('phoneNumber')">Teléfono requerido a 10 dígitos</span>
      </div>

      <div class="col-12 mb-3">
        <label> RFC <span class="input-required"> * </span> </label>
        <input class="form-control mt-2" type="text" maxlength="13" formControlName="rfc"
          [ngClass]="hasErrors('rfc')">
        <span *ngIf="isInvalid('rfc')">RFC inválido</span>
      </div>

      <div class="col-12 mb-3">
        <label> ¿Eres empleado de una empresa? <span class="input-required"> * </span> </label>
        <select class="form-control mt-2" formControlName="persontype" [ngClass]="hasErrors('persontype')">
          <option value="" > Seleccione... </option>
          <option [value]="item.key" *ngFor="let item of taxRegimens"> {{ item.value }} </option>
        </select>
        <span *ngIf="isInvalid('persontype')">Selecciona una opción válida</span>
      </div>

    </div>

  </form>

  <mat-dialog-actions align="center">
    <button class="btn btn-action" mat-button cdkFocusInitial (click)="send()"> Enviar </button>
  </mat-dialog-actions>

</section>
